import { jsx as _jsx } from "react/jsx-runtime";
import { usePublicWorkspace } from "~/components/PublicWorkspaceProvider";
import { WorkspaceAvatarAndName } from "~/components/WorkspaceAvatarAndName";
export const PublicWorkspaceInfo = ()=>{
    const { workspaceName, workspaceImage } = usePublicWorkspace();
    return /*#__PURE__*/ _jsx(WorkspaceAvatarAndName, {
        image: workspaceImage,
        name: workspaceName
    });
};
